export const TAHUN_AJARAN_OPTIONS = ["2023/2024", "2024/2025", "2025/2026", "2026/2027"];
export const SEMESTER_OPTIONS = [{ v: "I", label: "Semester I" }, { v: "II", label: "Semester II" }];

export const MAPEL_AKADEMIK = ["Matematika", "Pendidikan Pancasila", "PAI", "Bahasa Inggris", "IPAS", "Bahasa Indonesia", "Calistung", "PJOK", "IPA", "IPS"];
export const MAPEL_NON = ["Seni Musik", "Seni Tari", "Seni Lukis", "Tata Boga", "TIK", "Desain Grafis", "Prakarya", "Pengembangan Diri", "OMSK", "Komunikasi", "Pramuka", "Boccee", "Athletik"];
export const MAPEL_EKSTRA = ["Bahasa Reseptif", "Bahasa Ekspresif", "Preakademik", "Kemampuan Imitasi", "Bina Diri", "Kemampuan Wicara", "Calistung"];

export const NILAI_OPTIONS = [
  { v: "sangat_baik", label: "Sangat Baik", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { v: "baik", label: "Baik", color: "bg-sky-50 text-sky-700 border-sky-200" },
  { v: "cukup", label: "Cukup", color: "bg-amber-50 text-amber-700 border-amber-200" },
  { v: "kurang", label: "Kurang", color: "bg-rose-50 text-rose-700 border-rose-200" },
];

export const PROGRAM_LABEL = {
  ko_kurikuler: "Ko-Kurikuler",
  intra_kurikuler: "Intra-Kurikuler",
  ekstra_kurikuler: "Ekstra-Kurikuler",
};

export const JENJANG = ["TKLB", "SDLB", "SMPLB", "SMALB"];
export const FASE = ["Fase A", "Fase B", "Fase C", "Fase D", "Fase E", "Fase F"];

// Daftar mata pelajaran khusus untuk Capaian Pembelajaran (CP)
export const MAPEL_CP = [
  "Bahasa Indonesia",
  "Bahasa Inggris",
  "IPA",
  "IPS",
  "IPAS",
  "Matematika",
  "Pendidikan Agama Islam",
  "Pendidikan Pancasila",
  "PJOK",
  "Desain Grafis",
  "Holtikultura",
  "Seni Lukis",
  "Seni Musik",
  "Seni Tari",
  "Tata Boga",
  "TIK",
  "Progsus Autis",
  "Progsus Tunanetra",
  "Progsus Tunagrahita",
  "Progsus Tunarungu",
];
